import { render, staticRenderFns } from "./inventory-product-list.vue?vue&type=template&id=b3635796&scoped=true&"
import script from "./inventory-product-list.vue?vue&type=script&lang=js&"
export * from "./inventory-product-list.vue?vue&type=script&lang=js&"
import style0 from "./inventory-product-list.vue?vue&type=style&index=0&id=b3635796&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3635796",
  null
  
)

export default component.exports